<template>
  <div class="platform-notify-config" v-loading="loading">
    <el-form
      ref="form"
      :model="formModel"
      :rules="formRules"
      label-width="180px"
      label-position="left"
    >
      <el-form-item label="商贴预算提醒接收邮箱" prop="emails" required>
        <ContactList
          v-model="formModel.emails"
          type="email"
          tip="参加花呗商贴活动必填，最多添加 5 条"
        />
      </el-form-item>
      <el-form-item label="预算提醒接收手机" prop="mobiles" required>
        <ContactList
          v-model="formModel.mobiles"
          type="mobile"
          tip="参加花呗商贴活动商贴必填，最多添加 5 条"
        />
      </el-form-item>
    </el-form>

    <FooterSubmitButtons
      :loading="submitting"
      @cancel="handleCancel"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import ContactList from '../comps/contact-list'
import FooterSubmitButtons from '../comps/footer-submit-buttons'
import { getPlatformNotifyConfig, savePlatformNotifyConfig } from '../api'

const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const mobileReg = /^1\d{10}$/

function normalizeContactList (list) {
  if (!Array.isArray(list) || !list.length) return ['']
  return list
}

export default {
  name: 'PlatformNotifyConfig',
  components: {
    ContactList,
    FooterSubmitButtons
  },
  data () {
    const validateEmails = (rule, value, callback) => {
      const list = (value || []).map(item => String(item).trim()).filter(Boolean)
      if (!list.length) {
        callback(new Error('请填写商贴预算提醒接收邮箱'))
        return
      }
      if (list.length > 5) {
        callback(new Error('最多添加 5 条邮箱'))
        return
      }
      const invalid = list.find(email => !emailReg.test(email))
      if (invalid) {
        callback(new Error('请输入正确的邮箱地址'))
        return
      }
      callback()
    }
    const validateMobiles = (rule, value, callback) => {
      const list = (value || []).map(item => String(item).trim()).filter(Boolean)
      if (!list.length) {
        callback(new Error('请填写预算提醒接收手机'))
        return
      }
      if (list.length > 5) {
        callback(new Error('最多添加 5 条手机号'))
        return
      }
      const invalid = list.find(mobile => !mobileReg.test(mobile))
      if (invalid) {
        callback(new Error('请输入正确的手机号'))
        return
      }
      callback()
    }

    return {
      loading: false,
      submitting: false,
      formModel: {
        emails: [''],
        mobiles: ['']
      },
      formRules: {
        emails: [{ validator: validateEmails, trigger: 'change' }],
        mobiles: [{ validator: validateMobiles, trigger: 'change' }]
      }
    }
  },
  mounted () {
    this.loadConfig()
  },
  methods: {
    async loadConfig () {
      this.loading = true
      try {
        const res = await getPlatformNotifyConfig()
        const data = res.data.data || {}
        this.formModel.emails = normalizeContactList(data.emails)
        this.formModel.mobiles = normalizeContactList(data.mobiles)
      } catch (e) {
        this.$message.error('获取平台预留信息失败')
      } finally {
        this.loading = false
      }
    },
    buildPayload () {
      return {
        emails: this.formModel.emails.map(item => String(item).trim()).filter(Boolean),
        mobiles: this.formModel.mobiles.map(item => String(item).trim()).filter(Boolean)
      }
    },
    handleCancel () {
      this.$router.go(-1)
    },
    async handleSubmit () {
      try {
        await this.$refs.form.validate()
      } catch (e) {
        return
      }
      try {
        this.submitting = true
        await savePlatformNotifyConfig(this.buildPayload())
        this.$message.success('保存成功')
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || e.message || '保存失败'
        this.$message.error(msg)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.platform-notify-config {
  padding: 0 20px 90px;
}
</style>
